import { render, staticRenderFns } from "./DownloadHandler.vue?vue&type=template&id=020776cb"
import script from "./DownloadHandler.vue?vue&type=script&lang=ts"
export * from "./DownloadHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports